import { render, staticRenderFns } from "./communitynetwork.vue?vue&type=template&id=1a069f28&scoped=true"
import script from "./communitynetwork.vue?vue&type=script&lang=js"
export * from "./communitynetwork.vue?vue&type=script&lang=js"
import style0 from "./communitynetwork.vue?vue&type=style&index=0&id=1a069f28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a069f28",
  null
  
)

export default component.exports